import { render, staticRenderFns } from "./YellowCross.vue?vue&type=template&id=bcabb916&"
import script from "./YellowCross.vue?vue&type=script&lang=js&"
export * from "./YellowCross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports